import React from "react"
import PropTypes from "prop-types"
import { SwitchBox, SwitchInput, SwitchSlider } from "./styles"

const SwitchField = ({ handleInputChange, rounded, name, checked }) => {
  const onChange = (isChecked) => {
    if (handleInputChange !== undefined) handleInputChange(name, isChecked)
  }

  return (
    <SwitchBox class="switch">
      <SwitchInput type="checkbox" onChange={(event) => onChange(event.target.checked)} checked={checked} />
      <SwitchSlider rounded={rounded}></SwitchSlider>
    </SwitchBox>
  )
}

SwitchField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  rounded: PropTypes.bool,
  name: PropTypes.string
}

SwitchField.defaultProps = {
  handleInputChange: undefined,
  rounded: true
}

export default SwitchField
